/* eslint-disable */
import session from './session';

export default {
    getCellFirmwareList(filter) {
        return session.get(`firmware/cell/${filter}`);
    },
    getHeadFirmwareList(filter) {
        return session.get(`firmware/head/${filter}`);
    },
    getFirmware(firmwareType, id) {
        return session.get(`firmware/${firmwareType}/${id}/`);
    },
    deleteFirmware(firmwareType, id) {
        return session.delete(`firmware/${firmwareType}/${id}/`);
    },
    // Firmwares are immutable: the API exposes create/read/delete only, no PUT/PATCH.
    createFirmware(firmwareType, data) {
        return session.post(`firmware/${firmwareType}/`, data);
    },
};